import { createContext, useContext } from "react";

export interface AssistantUi {
  open: boolean;
  openPanel: () => void;
  closePanel: () => void;
  toggle: () => void;
}

export const AssistantUiContext = createContext<AssistantUi | null>(null);

export function useAssistantUi(): AssistantUi {
  const c = useContext(AssistantUiContext);
  if (!c) throw new Error("useAssistantUi must be used within AssistantUiProvider");
  return c;
}
